import { log } from 'log';
import { Form } from 'js/components/common/Form';
import React, { useCallback, useMemo } from 'react';
import { Button } from 'js/components/common/Button';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { required, number } from 'js/utils/Validation/validationRules';
import { IValidationMethodConfigRequired, IValidationMethodConfigNumber } from 'js/utils/Validation/types';
import { Radio, Input, Select, InputGroup, Checkbox, Toggle, DatePicker, FormErrorMessage } from 'js/components/common/FormFields';

import * as Types from './types';

import style from './FormTestComponent.scss';

export const FormTestComponentBare: React.FC<Types.IFormTestComponentProps> = ({ submittimeout = 2000, disabled }) => {

    const handleFormSubmit = useCallback(async (values) => {
        const message = await new Promise((resolve) => {
            setTimeout(() => {
                log('info', 'Form data', values);

                resolve('Can\'t establish intergalactic communication');
            }, Number(submittimeout));
        });

        console.log(message);

        return message;
    }, [submittimeout]);

    const initialValues = useMemo(() => ({
        experience: 'no'
    }), []);

    const validationConfig = useMemo(() => ({
        personalId: [
            required({ error: 'Personal number is required' }) as IValidationMethodConfigRequired,
            number({ error: 'Only numbers are allowed' }) as IValidationMethodConfigNumber
        ],
        password: [
            required({ error: 'Password is required' }) as IValidationMethodConfigRequired
        ],
        rank: [
            required({ error: 'Rank is required' }) as IValidationMethodConfigRequired
        ],
        dateOfBirth: [
            required({ error: 'Clone Date is required' }) as IValidationMethodConfigRequired
        ],
        salaryAmount: [
            number({ error: 'Only numbers are allowed' }) as IValidationMethodConfigNumber
        ],
        terms: [
            required({ error: 'This is required for any Stormtrooper' }) as IValidationMethodConfigNumber
        ]
    }), []);

    return (
        <>
            <p className={style.title}>{'Greetings Stormtroopers! Register to serve on Death Star'}</p>
            <Form
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationConfig={validationConfig}
                render={({ submitting, handleSubmit, values, submitError }) => (
                    <form
                        className={style.form}
                        onSubmit={event => event.preventDefault()}
                    >
                        {submitError && <FormErrorMessage message={submitError} /> }

                        <Input
                            type="text"
                            disabled={disabled}
                            aria-label="Personal number"
                            placeholder="Personal number"
                            label="Personal number"
                            hint="Please put your personal number here"
                            name="personalId"
                            id="personalId"
                            infoTooltip="Every Stormtroopers has one, just look at the front of your armor."
                            isLabelAsteriskEnabled
                            isPlaceholderAsteriskEnabled
                            rightIcon={() => (
                                <span
                                    className={style.swEmpireIcon}
                                />
                            )}
                        />
                        <Input
                            type="password"
                            showPasswordEye
                            disabled={disabled}
                            aria-label="your password"
                            placeholder="Password"
                            label="Password"
                            hint="Please put your password here"
                            name="password"
                            id="password'"
                            isLabelAsteriskEnabled
                            isPlaceholderAsteriskEnabled
                        />
                        <Select
                            disabled={disabled}
                            isLabelAsteriskEnabled
                            placeholder="Rank"
                            hint="Please choose your rank"
                            label="Rank"
                            options={[
                                {
                                    key: 1,
                                    value: 'trooper',
                                    label: 'Trooper'
                                },
                                {
                                    key: 2,
                                    value: 'corporal',
                                    label: 'Corporal'
                                },
                                {
                                    key: 3,
                                    value: 'sergeant',
                                    label: 'Sergeant'
                                },
                                {
                                    key: 4,
                                    value: 'squadLeader',
                                    label: 'Squad Leader'
                                },
                                {
                                    key: 5,
                                    value: 'chief',
                                    label: 'Chief'
                                },
                                {
                                    key: 6,
                                    value: 'capitan',
                                    label: 'Capitan'
                                }
                            ]}
                            aria-label="Rank"
                            name="rank"
                            id="rank"
                        />

                        <DatePicker
                            disabled={disabled}
                            id="dateOfBirth"
                            label="Clone Date"
                            name="dateOfBirth"
                            yearRange="past"
                            yearRangeNumber={100}
                            isLabelAsteriskEnabled
                            isPlaceholderAsteriskEnabled
                        />

                        <Input
                            type="text"
                            disabled={disabled}
                            inputMode="decimal"
                            aria-label="Desired salary"
                            placeholder="Amount"
                            label="Desired salary"
                            hint="Desired salary amount"
                            name="salaryAmount"
                            id="salaryAmount"
                            currencySymbol="GTS"
                        />

                        <InputGroup
                            direction="row"
                            label="Do you have a combat experience?"
                            infoTooltip="At least one enemy should be killed or captured"
                        >
                            <>
                                <Radio checked disabled={disabled} id="experience-1" aria-label="Yes" value="yes" label="Yes" name="experience" />
                                <Radio disabled={disabled} id="experience-2" aria-label="No" value="no" label="No" name="experience" />
                            </>
                        </InputGroup>

                        <InputGroup
                            label="What kind of vehicle have you driven?"
                        >
                            <>
                                <Checkbox disabled={disabled} id="landspeeder" aria-label="Landspeeder" label="Landspeeder" name="landspeeder" />
                                <Checkbox disabled={disabled} id="desertSkiff" aria-label="" label="Desert Skiff" name="desertSkiff" />
                                <Checkbox disabled={disabled} id="cloudCar" aria-label="" label="Cloud car" name="cloudCar" />
                                <Checkbox disabled={disabled} id="atSt" aria-label="" label="All Terrain Scout Transport (AT-ST)" name="atSt" />
                                <Checkbox disabled={disabled} id="atAt" aria-label="All Terrain Armored Transport (AT-AT)" label="All Terrain Armored Transport (AT-AT)" name="atAt" />
                            </>
                        </InputGroup>

                        <InputGroup label="Terms and condition">
                            <>
                                <Toggle
                                    disabled={disabled}
                                    id="terms"
                                    aria-label=""
                                    isLabelAsteriskEnabled
                                    label="I confirm that in case of death i will be reborn in clone chamber. Also you can be killed by darth vader if he desires so."
                                    name="terms"
                                />
                            </>
                        </InputGroup>

                        <Button
                            isNew
                            size="large"
                            disabled={submitting || disabled}
                            style={{ marginTop: '2rem' }}
                            onClick={handleSubmit}
                        >
                            {'Submit'}
                        </Button>
                    </form>
                )}
            >
            </Form>
        </>
    );
};

export const FormTestComponent = withComponent({})(FormTestComponentBare);

componentService.registerWebContentComponents({ FormTestComponent });
